import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-show-client',
  templateUrl: './show-client.component.html',
  styleUrls: ['./show-client.component.scss'],
})
export class ShowClientComponent implements OnInit {
  @ViewChild('sessionsInfo', { static: false }) sessionsInfo!: TemplateRef<any>;
  @ViewChild('paymentsClient', { static: false })
  paymentsClient!: TemplateRef<any>;
  @ViewChild('contractModal', { static: false })
  contractModal!: TemplateRef<any>;
  @ViewChild('paymentsModal', { static: false })
  paymentsModal!: TemplateRef<any>;
  @ViewChild('commentsHistory', { static: false })
  commentsHistory!: TemplateRef<any>;
  @ViewChild('paymentsPerPackage', { static: false }) paymentsPerPackage!: TemplateRef<any>;

  formPayments: any = FormGroup;
  modalContractClose: any;

  clientInfo: any = [];
  appointmentInfo: any = [];
  valorationsInfo: any = [];
  sessionsInfoData: any = [];
  paymentInfoData: any = [];
  breadcrumbs: any = [];
  paymentsFilter: any = [];
  dataInfo: any = [];
  userInfo: any = [];
  paymentsInfo: any = [];
  commentsPerAppt: any = [];
  submitted: boolean = false;
  submittedAppt: boolean = false;
  paramId: string | null = '';
  message: string = '';
  imageContract: string = '';
  label: string = '';
  messageDeleted: string = '';
  threatmentNumber: number = 0;
  packageId: number = 0;
  apptId: number = 0;
  idxValue: number = 0;
  payments: any;
  payment_methods: any;

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private modal: NgbModal,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.paramId = this.route.snapshot.paramMap.get('id');
    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Lista de clientes',
        path: '/clients/list',
        link: true,
      },
      {
        name: 'Historico del cliente',
        link: false,
      },
    ];

    this.validate();
    this.getClientInfo();
    this.getPayments();
    this.getPaymentMethods();
  }

  validate() {
    this.formPayments = this.fb.group({
      amount: ['', [Validators.required]],
      paymentMethodId: ['', [Validators.required]],
      terminal: [''],
      paymentId: ['0', [Validators.required]],
      apptId: ['', [Validators.required]],
    });
  }

  get f() {
    return this.formPayments.controls;
  }

  getClientInfo() {
    this.api.getById('clients/appoinments', Number(this.paramId)).subscribe({
      next: (client) => {
        console.log(client.client);
        this.clientInfo = client.client;
        this.appointmentInfo = client.client.appoinments;
        console.log('Appt Info: ', this.appointmentInfo);
        this.valorationsInfo = client.client.valorations;
        this.paymentsPerClient(client.client.id);
      },
      error: (err) => {},
    });
  }

  getPayments() {
    this.api.get('payments').subscribe({
      next: (payments) => {
        this.payments = payments.payments;
      },
      error: (err) => {},
    });
  }

  getPaymentMethods() {
    this.api.get('payment_methods').subscribe({
      next: (paymentMethods) => {
        this.payment_methods = paymentMethods.payment_methods;
      },
      error: (err) => {},
    });
  }

  checkPaymentMethods(evt: any): void {
    this.paymentsFilter = this.payments.filter(
      (data: any) => data.payment_method_id === Number(evt.target.value)
    );
  }

  showSessionsInfo(idData: number, num: number): void {
    this.threatmentNumber = num + 1;
    this.userInfo = this.appointmentInfo.filter(
      (data: any) => data.appoinment.id === idData
    );

    console.log('[userInfo]', this.userInfo);
    this.modal.open(this.sessionsInfo, { size: 'xl' });
  }

  closeAppoinmentPackage(id: number): void {
    this.submittedAppt = true;

    this.api.getById('packages/close', Number(id)).subscribe({
      next: (data) => {
        this.message = data.message;
      },
      error: (err) => {},
    });
  }

  showPayments(id: any): void {
    /*     this.api.getById('appoinment/payments', id).subscribe({
      next: (info) => {
        this.dataInfo = info.payments;
 */
    console.log('holas');
    this.paymentsPerClient(id);
    this.modal.open(this.paymentsClient, { size: 'xl' });
    /*       },
      error: (err) => {},
    }); */
  }

  private paymentsPerClient(id: number) {
    this.api.getById('appoinment/payments', id).subscribe({
      next: (info) => {
        this.dataInfo = info.payments;
        console.log('[Data Info]: ', this.dataInfo);
        //this.modal.open(this.paymentsClient, { size: 'xl' });
      },
      error: (err) => {},
    });
  }

  displayContract(contract: string) {
    let splitData = contract.split('/');
    this.imageContract = `https://www.laserclinic.mx/assets/${splitData[3]}/${splitData[4]}`;
    this.modalContractClose = this.modal.open(this.contractModal, {
      size: 'lg',
    });
  }

  displayPaymentsPerPackage(packageId: number, threatment: number): void {
    this.threatmentNumber = threatment;
    console.log('[dataInfo]: ', this.dataInfo);
    this.paymentInfoData = this.dataInfo.find((data: any) => data.package.id === packageId);
    console.log('Hola: ', this.paymentInfoData);

    this.modalContractClose = this.modal.open(this.paymentsPerPackage, { size: 'xl' });
  }

  displayAddPayment(threatNumber: number, apptId: number) {
    this.apptId = apptId;
    this.label = `Tratamiento ${threatNumber}`;
    this.formPayments.patchValue({
      apptId: this.apptId,
    });

    this.modalContractClose = this.modal.open(this.paymentsModal, {
      size: 'md',
    });
  }

  createNewPayment(): void {
    this.submitted = true;

    if (this.formPayments.invalid) {
      console.log(this.formPayments);
      this.submitted = false;
      return;
    }

    const obj = {
      paymentMethodId: this.formPayments.value.paymentMethodId,
      terminal: this.formPayments.value.terminal,
      paymentId: this.formPayments.value.paymentId,
      amount: this.formPayments.value.amount,
      apptId: this.formPayments.value.apptId,
      sessionId: 1,
    };

    console.log(obj);
    this.api.create('payments_sessions/advance', obj).subscribe({
      next: (data) => {
        this.message = data.message;

        if (data.printTicket.state_code == 'Bc') {
          this.api.onPrintRecipientPeninsula(data.printTicket);
        } else {
          this.api.onPrintRecipient(data.printTicket);
        }


        setTimeout(() => {
          this.resetAdvancePayments();
          this.submitted = false;
          this.message = '';
          location.reload();
        }, 3000);
      },
      error: (err) => {},
    });
  }

  async displayDataComments(apptId: Number) {
    this.api.getById('clients/comments', Number(apptId)).subscribe({
      next: (data) => {
        console.log('holas amigos');
        this.commentsPerAppt = data.comments;

        this.modalContractClose = this.modal.open(this.commentsHistory, {
          size: 'xl',
        });
      },
      error: (err) => {},
    });
  }

  deletePayment(idPayment: number, threatment: number): void {
    this.idxValue = threatment;
    this.api.delete('payments_sessions', idPayment).subscribe({
      next: (data) => {
        this.messageDeleted = data.message;
        console.log(this.messageDeleted);
        this.paymentsPerClient(data.data.clientId);

        setTimeout(() => {
          this.messageDeleted = '';
        }, 3000);
      },
      error: (err) => {},
    });
  }

  resetAdvancePayments() {
    this.formPayments.get('amount').setValue('');
    this.formPayments.get('paymentMethodId').setValue('');
    this.formPayments.get('paymentId').setValue(0);
    this.formPayments.get('terminal').setValue('');
    this.paymentsFilter = [];
    this.submitted = false;
    this.close();
  }

  close(): void {
    this.modalContractClose.close();
  }

  onPrintTicket(indexMain: number, index: number) {
    console.log('-- dataInfo: ', this.dataInfo[indexMain]);
    if (this.dataInfo[indexMain].printTicket[index].state_code == 'Bc') {
      this.api.onPrintRecipientPeninsula(this.dataInfo[indexMain].printTicket[index]);
    } else {
      this.api.onPrintRecipient(this.dataInfo[indexMain].printTicket[index]);
    }
  }
}
